// import React from "react";

import { useQuery } from "@apollo/client";

import gql from "graphql-tag";

import { default as datemath } from "@elastic/datemath";

import moment from "moment";

const TIMERANGE_QUERY = gql`
  {
    durationSelect @client {
      startDate
      endDate
    }
  }
`;

export default function useDateRange(interval?: any) {
  const { data /*, error, loading*/ } = useQuery(TIMERANGE_QUERY); // TODO as props?
  const startDate = moment(
    interval && interval.startDate
      ? datemath.parse(interval.startDate, { momentInstance: moment })
      : data.durationSelect.startDate
  ).unix();
  const endDate = moment(
    interval && interval.endDate
      ? datemath.parse(interval.endDate, {
          momentInstance: moment,
          roundUp: true,
        })
      : data.durationSelect.endDate
  ).unix();
  return {
    startDate,
    endDate,
  };
}
